var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var n, l$1, u$2, i$1, o$1, r$2, f$2, c$1 = {}, s$1 = [], a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, h$1 = Array.isArray;
function v$1(n2, l2) {
  for (var u2 in l2)
    n2[u2] = l2[u2];
  return n2;
}
function p$1(n2) {
  var l2 = n2.parentNode;
  l2 && l2.removeChild(n2);
}
function y$1(l2, u2, t2) {
  var i2, o2, r2, f2 = {};
  for (r2 in u2)
    "key" == r2 ? i2 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : f2[r2] = u2[r2];
  if (arguments.length > 2 && (f2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps)
    for (r2 in l2.defaultProps)
      void 0 === f2[r2] && (f2[r2] = l2.defaultProps[r2]);
  return d$1(l2, f2, i2, o2, null);
}
function d$1(n2, t2, i2, o2, r2) {
  var f2 = { type: n2, props: t2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == r2 ? ++u$2 : r2, __i: -1, __u: 0 };
  return null == r2 && null != l$1.vnode && l$1.vnode(f2), f2;
}
function g(n2) {
  return n2.children;
}
function b(n2, l2) {
  this.props = n2, this.context = l2;
}
function m$1(n2, l2) {
  if (null == l2)
    return n2.__ ? m$1(n2.__, n2.__i + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++)
    if (null != (u2 = n2.__k[l2]) && null != u2.__e)
      return u2.__e;
  return "function" == typeof n2.type ? m$1(n2) : null;
}
function w$1(n2, u2, t2) {
  var i2, o2 = n2.__v, r2 = o2.__e, f2 = n2.__P;
  if (f2)
    return (i2 = v$1({}, o2)).__v = o2.__v + 1, l$1.vnode && l$1.vnode(i2), M(f2, i2, o2, n2.__n, void 0 !== f2.ownerSVGElement, 32 & o2.__u ? [r2] : null, u2, null == r2 ? m$1(o2) : r2, !!(32 & o2.__u), t2), i2.__v = o2.__v, i2.__.__k[i2.__i] = i2, i2.__d = void 0, i2.__e != r2 && k$1(i2), i2;
}
function k$1(n2) {
  var l2, u2;
  if (null != (n2 = n2.__) && null != n2.__c) {
    for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++)
      if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
        n2.__e = n2.__c.base = u2.__e;
        break;
      }
    return k$1(n2);
  }
}
function x$1(n2) {
  (!n2.__d && (n2.__d = true) && i$1.push(n2) && !C$1.__r++ || o$1 !== l$1.debounceRendering) && ((o$1 = l$1.debounceRendering) || r$2)(C$1);
}
function C$1() {
  var n2, u2, t2, o2 = [], r2 = [];
  for (i$1.sort(f$2); n2 = i$1.shift(); )
    n2.__d && (t2 = i$1.length, u2 = w$1(n2, o2, r2) || u2, 0 === t2 || i$1.length > t2 ? (j$1(o2, u2, r2), r2.length = o2.length = 0, u2 = void 0, i$1.sort(f$2)) : u2 && l$1.__c && l$1.__c(u2, s$1));
  u2 && j$1(o2, u2, r2), C$1.__r = 0;
}
function P(n2, l2, u2, t2, i2, o2, r2, f2, e2, a2, h2) {
  var v2, p2, y2, d2, _2, g2 = t2 && t2.__k || s$1, b2 = l2.length;
  for (u2.__d = e2, S(u2, l2, g2), e2 = u2.__d, v2 = 0; v2 < b2; v2++)
    null != (y2 = u2.__k[v2]) && "boolean" != typeof y2 && "function" != typeof y2 && (p2 = -1 === y2.__i ? c$1 : g2[y2.__i] || c$1, y2.__i = v2, M(n2, y2, p2, i2, o2, r2, f2, e2, a2, h2), d2 = y2.__e, y2.ref && p2.ref != y2.ref && (p2.ref && N(p2.ref, null, y2), h2.push(y2.ref, y2.__c || d2, y2)), null == _2 && null != d2 && (_2 = d2), 65536 & y2.__u || p2.__k === y2.__k ? e2 = $(y2, e2, n2) : "function" == typeof y2.type && void 0 !== y2.__d ? e2 = y2.__d : d2 && (e2 = d2.nextSibling), y2.__d = void 0, y2.__u &= -196609);
  u2.__d = e2, u2.__e = _2;
}
function S(n2, l2, u2) {
  var t2, i2, o2, r2, f2, e2 = l2.length, c2 = u2.length, s2 = c2, a2 = 0;
  for (n2.__k = [], t2 = 0; t2 < e2; t2++)
    r2 = t2 + a2, null != (i2 = n2.__k[t2] = null == (i2 = l2[t2]) || "boolean" == typeof i2 || "function" == typeof i2 ? null : "string" == typeof i2 || "number" == typeof i2 || "bigint" == typeof i2 || i2.constructor == String ? d$1(null, i2, null, null, null) : h$1(i2) ? d$1(g, { children: i2 }, null, null, null) : void 0 === i2.constructor && i2.__b > 0 ? d$1(i2.type, i2.props, i2.key, i2.ref ? i2.ref : null, i2.__v) : i2) ? (i2.__ = n2, i2.__b = n2.__b + 1, f2 = I(i2, u2, r2, s2), i2.__i = f2, o2 = null, -1 !== f2 && (s2--, (o2 = u2[f2]) && (o2.__u |= 131072)), null == o2 || null === o2.__v ? (-1 == f2 && a2--, "function" != typeof i2.type && (i2.__u |= 65536)) : f2 !== r2 && (f2 === r2 + 1 ? a2++ : f2 > r2 ? s2 > e2 - r2 ? a2 += f2 - r2 : a2-- : f2 < r2 ? f2 == r2 - 1 && (a2 = f2 - r2) : a2 = 0, f2 !== t2 + a2 && (i2.__u |= 65536))) : (o2 = u2[r2]) && null == o2.key && o2.__e && 0 == (131072 & o2.__u) && (o2.__e == n2.__d && (n2.__d = m$1(o2)), O(o2, o2, false), u2[r2] = null, s2--);
  if (s2)
    for (t2 = 0; t2 < c2; t2++)
      null != (o2 = u2[t2]) && 0 == (131072 & o2.__u) && (o2.__e == n2.__d && (n2.__d = m$1(o2)), O(o2, o2));
}
function $(n2, l2, u2) {
  var t2, i2;
  if ("function" == typeof n2.type) {
    for (t2 = n2.__k, i2 = 0; t2 && i2 < t2.length; i2++)
      t2[i2] && (t2[i2].__ = n2, l2 = $(t2[i2], l2, u2));
    return l2;
  }
  n2.__e != l2 && (u2.insertBefore(n2.__e, l2 || null), l2 = n2.__e);
  do {
    l2 = l2 && l2.nextSibling;
  } while (null != l2 && 8 === l2.nodeType);
  return l2;
}
function I(n2, l2, u2, t2) {
  var i2 = n2.key, o2 = n2.type, r2 = u2 - 1, f2 = u2 + 1, e2 = l2[u2];
  if (null === e2 || e2 && i2 == e2.key && o2 === e2.type && 0 == (131072 & e2.__u))
    return u2;
  if (t2 > (null != e2 && 0 == (131072 & e2.__u) ? 1 : 0))
    for (; r2 >= 0 || f2 < l2.length; ) {
      if (r2 >= 0) {
        if ((e2 = l2[r2]) && 0 == (131072 & e2.__u) && i2 == e2.key && o2 === e2.type)
          return r2;
        r2--;
      }
      if (f2 < l2.length) {
        if ((e2 = l2[f2]) && 0 == (131072 & e2.__u) && i2 == e2.key && o2 === e2.type)
          return f2;
        f2++;
      }
    }
  return -1;
}
function T(n2, l2, u2) {
  "-" === l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || a$1.test(l2) ? u2 : u2 + "px";
}
function A$1(n2, l2, u2, t2, i2) {
  var o2;
  n:
    if ("style" === l2)
      if ("string" == typeof u2)
        n2.style.cssText = u2;
      else {
        if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2)
          for (l2 in t2)
            u2 && l2 in u2 || T(n2.style, l2, "");
        if (u2)
          for (l2 in u2)
            t2 && u2[l2] === t2[l2] || T(n2.style, l2, u2[l2]);
      }
    else if ("o" === l2[0] && "n" === l2[1])
      o2 = l2 !== (l2 = l2.replace(/(PointerCapture)$|Capture$/i, "$1")), l2 = l2.toLowerCase() in n2 ? l2.toLowerCase().slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + o2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = Date.now(), n2.addEventListener(l2, o2 ? L : D$1, o2)) : n2.removeEventListener(l2, o2 ? L : D$1, o2);
    else {
      if (i2)
        l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== l2 && "height" !== l2 && "href" !== l2 && "list" !== l2 && "form" !== l2 && "tabIndex" !== l2 && "download" !== l2 && "rowSpan" !== l2 && "colSpan" !== l2 && "role" !== l2 && l2 in n2)
        try {
          n2[l2] = null == u2 ? "" : u2;
          break n;
        } catch (n3) {
        }
      "function" == typeof u2 || (null == u2 || false === u2 && "-" !== l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, u2));
    }
}
function D$1(n2) {
  if (this.l) {
    var u2 = this.l[n2.type + false];
    if (n2.t) {
      if (n2.t <= u2.u)
        return;
    } else
      n2.t = Date.now();
    return u2(l$1.event ? l$1.event(n2) : n2);
  }
}
function L(n2) {
  if (this.l)
    return this.l[n2.type + true](l$1.event ? l$1.event(n2) : n2);
}
function M(n2, u2, t2, i2, o2, r2, f2, e2, c2, s2) {
  var a2, p2, y2, d2, _2, m2, w2, k2, x2, C2, S2, $2, H2, I2, T2, A2 = u2.type;
  if (void 0 !== u2.constructor)
    return null;
  128 & t2.__u && (c2 = !!(32 & t2.__u), r2 = [e2 = u2.__e = t2.__e]), (a2 = l$1.__b) && a2(u2);
  n:
    if ("function" == typeof A2)
      try {
        if (k2 = u2.props, x2 = (a2 = A2.contextType) && i2[a2.__c], C2 = a2 ? x2 ? x2.props.value : a2.__ : i2, t2.__c ? w2 = (p2 = u2.__c = t2.__c).__ = p2.__E : ("prototype" in A2 && A2.prototype.render ? u2.__c = p2 = new A2(k2, C2) : (u2.__c = p2 = new b(k2, C2), p2.constructor = A2, p2.render = q$1), x2 && x2.sub(p2), p2.props = k2, p2.state || (p2.state = {}), p2.context = C2, p2.__n = i2, y2 = p2.__d = true, p2.__h = [], p2._sb = []), null == p2.__s && (p2.__s = p2.state), null != A2.getDerivedStateFromProps && (p2.__s == p2.state && (p2.__s = v$1({}, p2.__s)), v$1(p2.__s, A2.getDerivedStateFromProps(k2, p2.__s))), d2 = p2.props, _2 = p2.state, p2.__v = u2, y2)
          null == A2.getDerivedStateFromProps && null != p2.componentWillMount && p2.componentWillMount(), null != p2.componentDidMount && p2.__h.push(p2.componentDidMount);
        else {
          if (null == A2.getDerivedStateFromProps && k2 !== d2 && null != p2.componentWillReceiveProps && p2.componentWillReceiveProps(k2, C2), !p2.__e && (null != p2.shouldComponentUpdate && false === p2.shouldComponentUpdate(k2, p2.__s, C2) || u2.__v === t2.__v)) {
            for (u2.__v !== t2.__v && (p2.props = k2, p2.state = p2.__s, p2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.forEach(function(n3) {
              n3 && (n3.__ = u2);
            }), S2 = 0; S2 < p2._sb.length; S2++)
              p2.__h.push(p2._sb[S2]);
            p2._sb = [], p2.__h.length && f2.push(p2);
            break n;
          }
          null != p2.componentWillUpdate && p2.componentWillUpdate(k2, p2.__s, C2), null != p2.componentDidUpdate && p2.__h.push(function() {
            p2.componentDidUpdate(d2, _2, m2);
          });
        }
        if (p2.context = C2, p2.props = k2, p2.__P = n2, p2.__e = false, $2 = l$1.__r, H2 = 0, "prototype" in A2 && A2.prototype.render) {
          for (p2.state = p2.__s, p2.__d = false, $2 && $2(u2), a2 = p2.render(p2.props, p2.state, p2.context), I2 = 0; I2 < p2._sb.length; I2++)
            p2.__h.push(p2._sb[I2]);
          p2._sb = [];
        } else
          do {
            p2.__d = false, $2 && $2(u2), a2 = p2.render(p2.props, p2.state, p2.context), p2.state = p2.__s;
          } while (p2.__d && ++H2 < 25);
        p2.state = p2.__s, null != p2.getChildContext && (i2 = v$1(v$1({}, i2), p2.getChildContext())), y2 || null == p2.getSnapshotBeforeUpdate || (m2 = p2.getSnapshotBeforeUpdate(d2, _2)), P(n2, h$1(T2 = null != a2 && a2.type === g && null == a2.key ? a2.props.children : a2) ? T2 : [T2], u2, t2, i2, o2, r2, f2, e2, c2, s2), p2.base = u2.__e, u2.__u &= -161, p2.__h.length && f2.push(p2), w2 && (p2.__E = p2.__ = null);
      } catch (n3) {
        u2.__v = null, c2 || null != r2 ? (u2.__e = e2, u2.__u |= c2 ? 160 : 32, r2[r2.indexOf(e2)] = null) : (u2.__e = t2.__e, u2.__k = t2.__k), l$1.__e(n3, u2, t2);
      }
    else
      null == r2 && u2.__v === t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : u2.__e = z$1(t2.__e, u2, t2, i2, o2, r2, f2, c2, s2);
  (a2 = l$1.diffed) && a2(u2);
}
function j$1(n2, u2, t2) {
  for (var i2 = 0; i2 < t2.length; i2++)
    N(t2[i2], t2[++i2], t2[++i2]);
  l$1.__c && l$1.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$1.__e(n3, u3.__v);
    }
  });
}
function z$1(l2, u2, t2, i2, o2, r2, f2, e2, s2) {
  var a2, v2, y2, d2, _2, g2, b2, w2 = t2.props, k2 = u2.props, x2 = u2.type;
  if ("svg" === x2 && (o2 = true), null != r2) {
    for (a2 = 0; a2 < r2.length; a2++)
      if ((_2 = r2[a2]) && "setAttribute" in _2 == !!x2 && (x2 ? _2.localName === x2 : 3 === _2.nodeType)) {
        l2 = _2, r2[a2] = null;
        break;
      }
  }
  if (null == l2) {
    if (null === x2)
      return document.createTextNode(k2);
    l2 = o2 ? document.createElementNS("http://www.w3.org/2000/svg", x2) : document.createElement(x2, k2.is && k2), r2 = null, e2 = false;
  }
  if (null === x2)
    w2 === k2 || e2 && l2.data === k2 || (l2.data = k2);
  else {
    if (r2 = r2 && n.call(l2.childNodes), w2 = t2.props || c$1, !e2 && null != r2)
      for (w2 = {}, a2 = 0; a2 < l2.attributes.length; a2++)
        w2[(_2 = l2.attributes[a2]).name] = _2.value;
    for (a2 in w2)
      _2 = w2[a2], "children" == a2 || ("dangerouslySetInnerHTML" == a2 ? y2 = _2 : "key" === a2 || a2 in k2 || A$1(l2, a2, null, _2, o2));
    for (a2 in k2)
      _2 = k2[a2], "children" == a2 ? d2 = _2 : "dangerouslySetInnerHTML" == a2 ? v2 = _2 : "value" == a2 ? g2 = _2 : "checked" == a2 ? b2 = _2 : "key" === a2 || e2 && "function" != typeof _2 || w2[a2] === _2 || A$1(l2, a2, _2, w2[a2], o2);
    if (v2)
      e2 || y2 && (v2.__html === y2.__html || v2.__html === l2.innerHTML) || (l2.innerHTML = v2.__html), u2.__k = [];
    else if (y2 && (l2.innerHTML = ""), P(l2, h$1(d2) ? d2 : [d2], u2, t2, i2, o2 && "foreignObject" !== x2, r2, f2, r2 ? r2[0] : t2.__k && m$1(t2, 0), e2, s2), null != r2)
      for (a2 = r2.length; a2--; )
        null != r2[a2] && p$1(r2[a2]);
    e2 || (a2 = "value", void 0 !== g2 && (g2 !== l2[a2] || "progress" === x2 && !g2 || "option" === x2 && g2 !== w2[a2]) && A$1(l2, a2, g2, w2[a2], false), a2 = "checked", void 0 !== b2 && b2 !== l2[a2] && A$1(l2, a2, b2, w2[a2], false));
  }
  return l2;
}
function N(n2, u2, t2) {
  try {
    "function" == typeof n2 ? n2(u2) : n2.current = u2;
  } catch (n3) {
    l$1.__e(n3, t2);
  }
}
function O(n2, u2, t2) {
  var i2, o2;
  if (l$1.unmount && l$1.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current !== n2.__e || N(i2, null, u2)), null != (i2 = n2.__c)) {
    if (i2.componentWillUnmount)
      try {
        i2.componentWillUnmount();
      } catch (n3) {
        l$1.__e(n3, u2);
      }
    i2.base = i2.__P = null, n2.__c = void 0;
  }
  if (i2 = n2.__k)
    for (o2 = 0; o2 < i2.length; o2++)
      i2[o2] && O(i2[o2], u2, t2 || "function" != typeof n2.type);
  t2 || null == n2.__e || p$1(n2.__e), n2.__ = n2.__e = n2.__d = void 0;
}
function q$1(n2, l2, u2) {
  return this.constructor(n2, u2);
}
function B$1(u2, t2, i2) {
  var o2, r2, f2, e2;
  l$1.__ && l$1.__(u2, t2), r2 = (o2 = "function" == typeof i2) ? null : i2 && i2.__k || t2.__k, f2 = [], e2 = [], M(t2, u2 = (!o2 && i2 || t2).__k = y$1(g, null, [u2]), r2 || c$1, c$1, void 0 !== t2.ownerSVGElement, !o2 && i2 ? [i2] : r2 ? null : t2.firstChild ? n.call(t2.childNodes) : null, f2, !o2 && i2 ? i2 : r2 ? r2.__e : t2.firstChild, o2, e2), u2.__d = void 0, j$1(f2, u2, e2);
}
n = s$1.slice, l$1 = { __e: function(n2, l2, u2, t2) {
  for (var i2, o2, r2; l2 = l2.__; )
    if ((i2 = l2.__c) && !i2.__)
      try {
        if ((o2 = i2.constructor) && null != o2.getDerivedStateFromError && (i2.setState(o2.getDerivedStateFromError(n2)), r2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), r2 = i2.__d), r2)
          return i2.__E = i2;
      } catch (l3) {
        n2 = l3;
      }
  throw n2;
} }, u$2 = 0, b.prototype.setState = function(n2, l2) {
  var u2;
  u2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v$1({}, this.state), "function" == typeof n2 && (n2 = n2(v$1({}, u2), this.props)), n2 && v$1(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), x$1(this));
}, b.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), x$1(this));
}, b.prototype.render = g, i$1 = [], r$2 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$2 = function(n2, l2) {
  return n2.__v.__b - l2.__v.__b;
}, C$1.__r = 0;
const LaunchButtonWrapper$1 = "ejx-LaunchButtonWrapper";
const LaunchRoot$1 = "ejx-LaunchRoot";
const CloseButton$1 = "ejx-CloseButton";
const LaunchButton$1 = "ejx-LaunchButton";
const LaunchRoot__variantminimal$1 = "ejx-LaunchRoot__variantminimal";
const LaunchRoot__pickvisible$1 = "ejx-LaunchRoot__pickvisible";
const Button$1 = "ejx-Button";
const Button__Deemphasize$1 = "ejx-Button__Deemphasize";
const Button__Small$1 = "ejx-Button__Small";
const SessionButtonWrapper$1 = "ejx-SessionButtonWrapper";
const LaunchRoot__variantdefault$1 = "ejx-LaunchRoot__variantdefault";
const EJXLogoShape$1 = "ejx-EJXLogoShape";
const EJXLogoShape__Close$1 = "ejx-EJXLogoShape__Close";
const EJXLogoShape__Secondary$1 = "ejx-EJXLogoShape__Secondary";
const EJXText$1 = "ejx-EJXText";
const styles$3 = {
  "user-select-none": "ejx-user-select-none",
  LaunchButtonWrapper: LaunchButtonWrapper$1,
  LaunchRoot: LaunchRoot$1,
  CloseButton: CloseButton$1,
  LaunchButton: LaunchButton$1,
  LaunchRoot__variantminimal: LaunchRoot__variantminimal$1,
  LaunchRoot__pickvisible: LaunchRoot__pickvisible$1,
  Button: Button$1,
  Button__Deemphasize: Button__Deemphasize$1,
  Button__Small: Button__Small$1,
  SessionButtonWrapper: SessionButtonWrapper$1,
  LaunchRoot__variantdefault: LaunchRoot__variantdefault$1,
  EJXLogoShape: EJXLogoShape$1,
  EJXLogoShape__Close: EJXLogoShape__Close$1,
  EJXLogoShape__Secondary: EJXLogoShape__Secondary$1,
  EJXText: EJXText$1
};
var t, r$1, u$1, i, o = 0, f$1 = [], c = [], e = l$1, a = e.__b, v = e.__r, l = e.diffed, m = e.__c, s = e.unmount, d = e.__;
function h(n2, t2) {
  e.__h && e.__h(r$1, n2, o || t2), o = 0;
  var u2 = r$1.__H || (r$1.__H = { __: [], __h: [] });
  return n2 >= u2.__.length && u2.__.push({ __V: c }), u2.__[n2];
}
function p(n2) {
  return o = 1, y(D, n2);
}
function y(n2, u2, i2) {
  var o2 = h(t++, 2);
  if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : D(void 0, u2), function(n3) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r$1, !r$1.u)) {
    var f2 = function(n3, t2, r2) {
      if (!o2.__c.__H)
        return true;
      var u3 = o2.__c.__H.__.filter(function(n4) {
        return !!n4.__c;
      });
      if (u3.every(function(n4) {
        return !n4.__N;
      }))
        return !c2 || c2.call(this, n3, t2, r2);
      var i3 = false;
      return u3.forEach(function(n4) {
        if (n4.__N) {
          var t3 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
        }
      }), !(!i3 && o2.__c.props === n3) && (!c2 || c2.call(this, n3, t2, r2));
    };
    r$1.u = true;
    var c2 = r$1.shouldComponentUpdate, e2 = r$1.componentWillUpdate;
    r$1.componentWillUpdate = function(n3, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n3, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n3, t2, r2);
    }, r$1.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
function _(n2, u2) {
  var i2 = h(t++, 3);
  !e.__s && C(i2.__H, u2) && (i2.__ = n2, i2.i = u2, r$1.__H.__h.push(i2));
}
function A(n2, u2) {
  var i2 = h(t++, 4);
  !e.__s && C(i2.__H, u2) && (i2.__ = n2, i2.i = u2, r$1.__h.push(i2));
}
function F(n2) {
  return o = 5, q(function() {
    return { current: n2 };
  }, []);
}
function q(n2, r2) {
  var u2 = h(t++, 7);
  return C(u2.__H, r2) ? (u2.__V = n2(), u2.i = r2, u2.__h = n2, u2.__V) : u2.__;
}
function x(n2, t2) {
  return o = 8, q(function() {
    return n2;
  }, t2);
}
function j() {
  for (var n2; n2 = f$1.shift(); )
    if (n2.__P && n2.__H)
      try {
        n2.__H.__h.forEach(z), n2.__H.__h.forEach(B), n2.__H.__h = [];
      } catch (t2) {
        n2.__H.__h = [], e.__e(t2, n2.__v);
      }
}
e.__b = function(n2) {
  r$1 = null, a && a(n2);
}, e.__ = function(n2, t2) {
  n2 && t2.__k && t2.__k.__m && (n2.__m = t2.__k.__m), d && d(n2, t2);
}, e.__r = function(n2) {
  v && v(n2), t = 0;
  var i2 = (r$1 = n2.__c).__H;
  i2 && (u$1 === r$1 ? (i2.__h = [], r$1.__h = [], i2.__.forEach(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.__V = c, n3.__N = n3.i = void 0;
  })) : (i2.__h.forEach(z), i2.__h.forEach(B), i2.__h = [], t = 0)), u$1 = r$1;
}, e.diffed = function(n2) {
  l && l(n2);
  var t2 = n2.__c;
  t2 && t2.__H && (t2.__H.__h.length && (1 !== f$1.push(t2) && i === e.requestAnimationFrame || ((i = e.requestAnimationFrame) || w)(j)), t2.__H.__.forEach(function(n3) {
    n3.i && (n3.__H = n3.i), n3.__V !== c && (n3.__ = n3.__V), n3.i = void 0, n3.__V = c;
  })), u$1 = r$1 = null;
}, e.__c = function(n2, t2) {
  t2.some(function(n3) {
    try {
      n3.__h.forEach(z), n3.__h = n3.__h.filter(function(n4) {
        return !n4.__ || B(n4);
      });
    } catch (r2) {
      t2.some(function(n4) {
        n4.__h && (n4.__h = []);
      }), t2 = [], e.__e(r2, n3.__v);
    }
  }), m && m(n2, t2);
}, e.unmount = function(n2) {
  s && s(n2);
  var t2, r2 = n2.__c;
  r2 && r2.__H && (r2.__H.__.forEach(function(n3) {
    try {
      z(n3);
    } catch (n4) {
      t2 = n4;
    }
  }), r2.__H = void 0, t2 && e.__e(t2, r2.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n2) {
  var t2, r2 = function() {
    clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n2);
  }, u2 = setTimeout(r2, 100);
  k && (t2 = requestAnimationFrame(r2));
}
function z(n2) {
  var t2 = r$1, u2 = n2.__c;
  "function" == typeof u2 && (n2.__c = void 0, u2()), r$1 = t2;
}
function B(n2) {
  var t2 = r$1;
  n2.__c = n2.__(), r$1 = t2;
}
function C(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n2[r2];
  });
}
function D(n2, t2) {
  return "function" == typeof t2 ? t2(n2) : t2;
}
const getSupportedXRSessions = (sessions) => {
  return new Promise((res) => {
    if (navigator.xr && navigator.xr.isSessionSupported) {
      const result = sessions.map((session) => {
        var _a;
        return (_a = navigator.xr) == null ? void 0 : _a.isSessionSupported(session).then((supported) => {
          console.debug(`Checking if ${session} is supported? ${supported}`);
          if (supported) {
            return session;
          }
        });
      });
      Promise.all(result).then((supportedSessions) => {
        res(supportedSessions.filter((v2) => v2 !== void 0));
      });
    } else {
      res([]);
    }
  });
};
var CheckXRStatus = /* @__PURE__ */ ((CheckXRStatus2) => {
  CheckXRStatus2["OK"] = "OK";
  CheckXRStatus2["IOS"] = "IOS";
  CheckXRStatus2["NO_FULLSCREEN"] = "NO_FULLSCREEN";
  CheckXRStatus2["ANDROID_NO_XR"] = "ANDROID_NO_XR";
  CheckXRStatus2["NO_HTTPS"] = "NO_HTTPS";
  CheckXRStatus2["SHOW_POPUP"] = "SHOW_POPUP";
  CheckXRStatus2["NAVIGATOR_XR_PERMISSIONS"] = "NAVIGATOR_XR_PERMISSIONS";
  CheckXRStatus2["SHOW_IFRAME_REDIRECT"] = "SHOW_IFRAME_REDIRECT";
  CheckXRStatus2["USER_REJECT_AR"] = "USER_REJECT_AR";
  CheckXRStatus2["USER_REJECT_VR"] = "USER_REJECT_VR";
  return CheckXRStatus2;
})(CheckXRStatus || {});
const makeError = (status) => ({
  status,
  sessions: []
});
const checkXr = async (requiredSessions) => {
  var _a, _b;
  let hasXrPermissions = true;
  try {
    if (!((_a = navigator.xr) == null ? void 0 : _a.isSessionSupported)) {
      hasXrPermissions = false;
    } else {
      await navigator.xr.isSessionSupported("immersive-ar");
    }
  } catch (error) {
    hasXrPermissions = false;
  }
  const hasFullscreen = document.fullscreenEnabled ?? false;
  const validSessions = hasXrPermissions ? await getSupportedXRSessions(requiredSessions) : [];
  const iOS = /^iP/.test(navigator.platform) || /^Mac/.test(navigator.platform) && navigator.maxTouchPoints > 4;
  const width = window.innerWidth;
  const isMobile = ((_b = navigator.userAgentData) == null ? void 0 : _b.mobile) || iOS || width && width < 500;
  const isSecure = window.location.protocol === "https:";
  const isEyeJackApp = navigator.userAgent.includes("EyeJack");
  if ((hasFullscreen || isEyeJackApp) && validSessions.length > 0)
    return {
      status: "OK",
      sessions: validSessions
    };
  if (isMobile) {
    if (iOS) {
      return makeError(
        "IOS"
        /* IOS */
      );
    } else {
      if (!isSecure)
        return makeError(
          "NO_HTTPS"
          /* NO_HTTPS */
        );
      if (!hasXrPermissions)
        return makeError(
          "NAVIGATOR_XR_PERMISSIONS"
          /* NAVIGATOR_XR_PERMISSIONS */
        );
      if (!hasFullscreen)
        return makeError(
          "NO_FULLSCREEN"
          /* NO_FULLSCREEN */
        );
      if (validSessions.length === 0)
        return makeError(
          "ANDROID_NO_XR"
          /* ANDROID_NO_XR */
        );
    }
  }
  return makeError(
    "SHOW_POPUP"
    /* SHOW_POPUP */
  );
};
const broadcastEvent = (event) => {
  window.postMessage({
    type: event.type,
    ...event.detail
  }, "*");
  if (window.parent) {
    window.parent.postMessage({
      type: event.type,
      ...event.detail,
      src: window.location.pathname
    }, "*");
  }
};
const selectElement = (element) => {
  const selection = window.getSelection();
  if (!selection)
    return void 0;
  selection.removeAllRanges();
  const range = document.createRange();
  range.selectNodeContents(element);
  selection.addRange(range);
  return void 0;
};
const needsUrlEncoded = (str) => /[ \&\=\?\%\x80-\xFF]/.test(str);
function isInIframe() {
  try {
    const notTop = window.self !== window.top;
    return notTop;
  } catch (e2) {
    return true;
  }
}
class FullscreenError extends Error {
  constructor() {
    super("This device, website, or iframe does not support fullscreen.");
    __publicField(this, "errorType", "FullscreenError");
  }
}
class XRPermissionsError extends Error {
  constructor() {
    super('This device, website, or iframe does not permit the "xr" feature.');
    __publicField(this, "errorType", "XRPermissionsError");
  }
}
class InvalidXRSessionModeError extends Error {
  constructor(invalidSessionMode) {
    super(`The provided session mode "${invalidSessionMode}" is not valid.`);
    __publicField(this, "errorType", "InvalidXRSessionModeError");
  }
}
class UnknownError extends Error {
  constructor(extraInfo) {
    const extraInfoStr = extraInfo instanceof Error ? extraInfo.message : extraInfo;
    super(`An error occured.` + (extraInfo !== void 0 ? `
 Reason:${extraInfoStr}` : ""));
    __publicField(this, "errorType", "UnknownError");
    if (extraInfo instanceof Error) {
      this.cause = extraInfo;
    }
  }
}
class NoHttpsError extends Error {
  constructor() {
    super("Website not served over https.  Https is required for WebXR.");
    __publicField(this, "errorType", "NoHttpsError");
  }
}
class IframeCantRedirectError extends Error {
  constructor() {
    super("Website is served in an iframe and therefore can't redirect to the EyeJackX player to launch on iOS.");
    __publicField(this, "errorType", "IframeCantRedirectError");
  }
}
function ejxLauncherErrorFromCheckXRStatus(status) {
  switch (status) {
    case CheckXRStatus.ANDROID_NO_XR:
      return new XRPermissionsError();
    case CheckXRStatus.NO_HTTPS:
      return new NoHttpsError();
    case CheckXRStatus.NAVIGATOR_XR_PERMISSIONS:
      return new XRPermissionsError();
    case CheckXRStatus.SHOW_IFRAME_REDIRECT:
      return new IframeCantRedirectError();
    case CheckXRStatus.NO_FULLSCREEN:
      return new FullscreenError();
  }
}
const useXRSession = (opts) => {
  const [isARSupported, setIsARSupported] = p(false);
  const [errorReason, setErrorReason] = p(void 0);
  const onStartup = async () => {
    try {
      if (location.protocol !== "https:") {
        setErrorReason("Needs HTTPS");
      } else if (!navigator.xr || !navigator.xr.isSessionSupported) {
        setErrorReason("No support for XR.");
      } else if (!await navigator.xr.isSessionSupported("inline")) {
        setErrorReason("No support for `inline` session.");
      }
    } catch (reason) {
      if (reason instanceof TypeError && opts.onError) {
        opts.onError(new InvalidXRSessionModeError("inline"));
      } else if (reason instanceof DOMException && opts.onError) {
        opts.onError(new XRPermissionsError());
      } else if (opts.onError) {
        opts.onError(new UnknownError(reason));
      }
    }
    setIsARSupported(true);
    window.addEventListener("message", (event) => {
      if (event.data.type === "@eyejack/ejx-launcher-button:start") {
        tryStartXR(event.data.sessionType);
      } else if (event.data.type === "@eyejack/ejx-launcher-button:stop") {
        tryStopXR();
      }
    });
    const customEvent = new CustomEvent("@eyejack/ejx-launcher-button:ready", {
      detail: {}
    });
    broadcastEvent(customEvent);
  };
  _(() => {
    onStartup();
  }, []);
  const handleSessionEnded = () => {
    setSession(void 0);
    const ev = new CustomEvent("@eyejack/ejx-launcher-button:stopped");
    broadcastEvent(ev);
  };
  const [session, setSession] = p();
  const [currentSessionType, setCurrentSessionType] = p();
  const tryStartXR = async (sessionType = "immersive-ar") => {
    if (opts.onBeforeStart)
      opts.onBeforeStart(sessionType);
    const sesh = await opts.xrSessionBuilder(sessionType);
    if (sesh) {
      setCurrentSessionType(sessionType);
      sesh.addEventListener("end", handleSessionEnded);
      setSession(sesh);
      const ev = new CustomEvent("@eyejack/ejx-launcher-button:started", {
        detail: {
          sessionType
        }
      });
      broadcastEvent(ev);
      if (opts.onStart)
        opts.onStart(sessionType, sesh);
    }
  };
  const tryStopXR = async () => {
    if (session) {
      if (opts.onBeforeEnd && currentSessionType)
        opts.onBeforeEnd(currentSessionType, session);
      await opts.xrSessionEnder(session);
      if (opts.onEnd && currentSessionType)
        opts.onEnd(currentSessionType);
      setCurrentSessionType(void 0);
    }
  };
  return {
    supported: isARSupported,
    errorReason,
    session,
    tryStartXR,
    tryStopXR,
    currentSessionType
  };
};
function r(e2) {
  var t2, f2, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2)
    n2 += e2;
  else if ("object" == typeof e2)
    if (Array.isArray(e2))
      for (t2 = 0; t2 < e2.length; t2++)
        e2[t2] && (f2 = r(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
    else
      for (t2 in e2)
        e2[t2] && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function clsx() {
  for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length; )
    (e2 = arguments[f2++]) && (t2 = r(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
const LauncherPopup$1 = "ejx-LauncherPopup";
const LaunchButtonWrapper = "ejx-LaunchButtonWrapper";
const LaunchRoot = "ejx-LaunchRoot";
const CloseButton = "ejx-CloseButton";
const LaunchButton = "ejx-LaunchButton";
const LaunchRoot__variantminimal = "ejx-LaunchRoot__variantminimal";
const LaunchRoot__pickvisible = "ejx-LaunchRoot__pickvisible";
const Button = "ejx-Button";
const Button__Deemphasize = "ejx-Button__Deemphasize";
const Button__Small = "ejx-Button__Small";
const SessionButtonWrapper = "ejx-SessionButtonWrapper";
const LaunchRoot__variantdefault = "ejx-LaunchRoot__variantdefault";
const EJXLogoShape = "ejx-EJXLogoShape";
const EJXLogoShape__Close = "ejx-EJXLogoShape__Close";
const EJXLogoShape__Secondary = "ejx-EJXLogoShape__Secondary";
const EJXText = "ejx-EJXText";
const LauncherPopup__Visible = "ejx-LauncherPopup__Visible";
const LauncherPopup_Version = "ejx-LauncherPopup_Version";
const styles$2 = {
  "user-select-none": "ejx-user-select-none",
  LauncherPopup: LauncherPopup$1,
  LaunchButtonWrapper,
  LaunchRoot,
  CloseButton,
  LaunchButton,
  LaunchRoot__variantminimal,
  LaunchRoot__pickvisible,
  Button,
  Button__Deemphasize,
  Button__Small,
  SessionButtonWrapper,
  LaunchRoot__variantdefault,
  EJXLogoShape,
  EJXLogoShape__Close,
  EJXLogoShape__Secondary,
  EJXText,
  LauncherPopup__Visible,
  LauncherPopup_Version
};
const LogoImg = "data:image/svg+xml;base64,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";
const PKG_VERSION = "0.7.1";
var f = 0;
function u(e2, t2, n2, o2, i2, u2) {
  var a2, c2, p2 = {};
  for (c2 in t2)
    "ref" == c2 ? a2 = t2[c2] : p2[c2] = t2[c2];
  var l2 = { type: e2, props: p2, key: n2, ref: a2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: --f, __i: -1, __u: 0, __source: i2, __self: u2 };
  if ("function" == typeof e2 && (a2 = e2.defaultProps))
    for (c2 in a2)
      void 0 === p2[c2] && (p2[c2] = a2[c2]);
  return l$1.vnode && l$1.vnode(l2), l2;
}
const LauncherPopup = (props) => {
  return u("div", {
    className: clsx(styles$2.LauncherPopup, props.visible && styles$2.LauncherPopup__Visible, props.className),
    style: {
      "--bottom-offset": `${props.bottomOffset ?? 20}px`
    },
    children: [u("div", {
      children: u("img", {
        src: LogoImg,
        style: {
          height: "18px",
          marginBottom: "5px"
        }
      })
    }), u("p", {
      className: styles$2.LauncherPopup_Version,
      children: PKG_VERSION
    }), props.children]
  });
};
let G = null;
class H {
}
H.render = function(w2, B2) {
  G(w2, B2);
};
self.QrCreator = H;
(function(w2) {
  function B2(t2, c2, a2, e2) {
    var b2 = {}, h2 = w2(a2, c2);
    h2.u(t2);
    h2.J();
    e2 = e2 || 0;
    var r2 = h2.h(), d2 = h2.h() + 2 * e2;
    b2.text = t2;
    b2.level = c2;
    b2.version = a2;
    b2.O = d2;
    b2.a = function(b3, a3) {
      b3 -= e2;
      a3 -= e2;
      return 0 > b3 || b3 >= r2 || 0 > a3 || a3 >= r2 ? false : h2.a(b3, a3);
    };
    return b2;
  }
  function C2(t2, c2, a2, e2, b2, h2, r2, d2, g2, x2) {
    function u2(b3, a3, f2, c3, d3, r3, g3) {
      b3 ? (t2.lineTo(a3 + r3, f2 + g3), t2.arcTo(a3, f2, c3, d3, h2)) : t2.lineTo(a3, f2);
    }
    r2 ? t2.moveTo(c2 + h2, a2) : t2.moveTo(c2, a2);
    u2(d2, e2, a2, e2, b2, -h2, 0);
    u2(g2, e2, b2, c2, b2, 0, -h2);
    u2(x2, c2, b2, c2, a2, h2, 0);
    u2(r2, c2, a2, e2, a2, 0, h2);
  }
  function z2(t2, c2, a2, e2, b2, h2, r2, d2, g2, x2) {
    function u2(b3, a3, c3, d3) {
      t2.moveTo(b3 + c3, a3);
      t2.lineTo(
        b3,
        a3
      );
      t2.lineTo(b3, a3 + d3);
      t2.arcTo(b3, a3, b3 + c3, a3, h2);
    }
    r2 && u2(c2, a2, h2, h2);
    d2 && u2(e2, a2, -h2, h2);
    g2 && u2(e2, b2, -h2, -h2);
    x2 && u2(c2, b2, h2, -h2);
  }
  function A2(t2, c2) {
    var a2 = c2.fill;
    if ("string" === typeof a2)
      t2.fillStyle = a2;
    else {
      var e2 = a2.type, b2 = a2.colorStops;
      a2 = a2.position.map((b3) => Math.round(b3 * c2.size));
      if ("linear-gradient" === e2)
        var h2 = t2.createLinearGradient.apply(t2, a2);
      else if ("radial-gradient" === e2)
        h2 = t2.createRadialGradient.apply(t2, a2);
      else
        throw Error("Unsupported fill");
      b2.forEach(([b3, a3]) => {
        h2.addColorStop(b3, a3);
      });
      t2.fillStyle = h2;
    }
  }
  function y2(t2, c2) {
    a: {
      var a2 = c2.text, e2 = c2.v, b2 = c2.N, h2 = c2.K, r2 = c2.P;
      b2 = Math.max(1, b2 || 1);
      for (h2 = Math.min(40, h2 || 40); b2 <= h2; b2 += 1)
        try {
          var d2 = B2(a2, e2, b2, r2);
          break a;
        } catch (J) {
        }
      d2 = void 0;
    }
    if (!d2)
      return null;
    a2 = t2.getContext("2d");
    c2.background && (a2.fillStyle = c2.background, a2.fillRect(c2.left, c2.top, c2.size, c2.size));
    e2 = d2.O;
    h2 = c2.size / e2;
    a2.beginPath();
    for (r2 = 0; r2 < e2; r2 += 1)
      for (b2 = 0; b2 < e2; b2 += 1) {
        var g2 = a2, x2 = c2.left + b2 * h2, u2 = c2.top + r2 * h2, p2 = r2, q2 = b2, f2 = d2.a, k2 = x2 + h2, m2 = u2 + h2, D2 = p2 - 1, E = p2 + 1, n2 = q2 - 1, l2 = q2 + 1, y3 = Math.floor(Math.min(0.5, Math.max(0, c2.R)) * h2), v3 = f2(p2, q2), I2 = f2(D2, n2), w3 = f2(D2, q2);
        D2 = f2(D2, l2);
        var F2 = f2(p2, l2);
        l2 = f2(E, l2);
        q2 = f2(
          E,
          q2
        );
        E = f2(E, n2);
        p2 = f2(p2, n2);
        x2 = Math.round(x2);
        u2 = Math.round(u2);
        k2 = Math.round(k2);
        m2 = Math.round(m2);
        v3 ? C2(g2, x2, u2, k2, m2, y3, !w3 && !p2, !w3 && !F2, !q2 && !F2, !q2 && !p2) : z2(g2, x2, u2, k2, m2, y3, w3 && p2 && I2, w3 && F2 && D2, q2 && F2 && l2, q2 && p2 && E);
      }
    A2(a2, c2);
    a2.fill();
    return t2;
  }
  var v2 = { minVersion: 1, maxVersion: 40, ecLevel: "L", left: 0, top: 0, size: 200, fill: "#000", background: null, text: "no text", radius: 0.5, quiet: 0 };
  G = function(t2, c2) {
    var a2 = {};
    Object.assign(a2, v2, t2);
    a2.N = a2.minVersion;
    a2.K = a2.maxVersion;
    a2.v = a2.ecLevel;
    a2.left = a2.left;
    a2.top = a2.top;
    a2.size = a2.size;
    a2.fill = a2.fill;
    a2.background = a2.background;
    a2.text = a2.text;
    a2.R = a2.radius;
    a2.P = a2.quiet;
    if (c2 instanceof HTMLCanvasElement) {
      if (c2.width !== a2.size || c2.height !== a2.size)
        c2.width = a2.size, c2.height = a2.size;
      c2.getContext("2d").clearRect(0, 0, c2.width, c2.height);
      y2(c2, a2);
    } else
      t2 = document.createElement("canvas"), t2.width = a2.size, t2.height = a2.size, a2 = y2(t2, a2), c2.appendChild(a2);
  };
})(function() {
  function w2(c2) {
    var a2 = C2.s(c2);
    return { S: function() {
      return 4;
    }, b: function() {
      return a2.length;
    }, write: function(c3) {
      for (var b2 = 0; b2 < a2.length; b2 += 1)
        c3.put(a2[b2], 8);
    } };
  }
  function B2() {
    var c2 = [], a2 = 0, e2 = {
      B: function() {
        return c2;
      },
      c: function(b2) {
        return 1 == (c2[Math.floor(b2 / 8)] >>> 7 - b2 % 8 & 1);
      },
      put: function(b2, h2) {
        for (var a3 = 0; a3 < h2; a3 += 1)
          e2.m(1 == (b2 >>> h2 - a3 - 1 & 1));
      },
      f: function() {
        return a2;
      },
      m: function(b2) {
        var h2 = Math.floor(a2 / 8);
        c2.length <= h2 && c2.push(0);
        b2 && (c2[h2] |= 128 >>> a2 % 8);
        a2 += 1;
      }
    };
    return e2;
  }
  function C2(c2, a2) {
    function e2(b3, h3) {
      for (var a3 = -1; 7 >= a3; a3 += 1)
        if (!(-1 >= b3 + a3 || d2 <= b3 + a3))
          for (var c3 = -1; 7 >= c3; c3 += 1)
            -1 >= h3 + c3 || d2 <= h3 + c3 || (r2[b3 + a3][h3 + c3] = 0 <= a3 && 6 >= a3 && (0 == c3 || 6 == c3) || 0 <= c3 && 6 >= c3 && (0 == a3 || 6 == a3) || 2 <= a3 && 4 >= a3 && 2 <= c3 && 4 >= c3 ? true : false);
    }
    function b2(b3, a3) {
      for (var f2 = d2 = 4 * c2 + 17, k2 = Array(f2), m2 = 0; m2 < f2; m2 += 1) {
        k2[m2] = Array(f2);
        for (var p2 = 0; p2 < f2; p2 += 1)
          k2[m2][p2] = null;
      }
      r2 = k2;
      e2(0, 0);
      e2(d2 - 7, 0);
      e2(0, d2 - 7);
      f2 = y2.G(c2);
      for (k2 = 0; k2 < f2.length; k2 += 1)
        for (m2 = 0; m2 < f2.length; m2 += 1) {
          p2 = f2[k2];
          var q2 = f2[m2];
          if (null == r2[p2][q2])
            for (var n2 = -2; 2 >= n2; n2 += 1)
              for (var l2 = -2; 2 >= l2; l2 += 1)
                r2[p2 + n2][q2 + l2] = -2 == n2 || 2 == n2 || -2 == l2 || 2 == l2 || 0 == n2 && 0 == l2;
        }
      for (f2 = 8; f2 < d2 - 8; f2 += 1)
        null == r2[f2][6] && (r2[f2][6] = 0 == f2 % 2);
      for (f2 = 8; f2 < d2 - 8; f2 += 1)
        null == r2[6][f2] && (r2[6][f2] = 0 == f2 % 2);
      f2 = y2.w(h2 << 3 | a3);
      for (k2 = 0; 15 > k2; k2 += 1)
        m2 = !b3 && 1 == (f2 >> k2 & 1), r2[6 > k2 ? k2 : 8 > k2 ? k2 + 1 : d2 - 15 + k2][8] = m2, r2[8][8 > k2 ? d2 - k2 - 1 : 9 > k2 ? 15 - k2 : 14 - k2] = m2;
      r2[d2 - 8][8] = !b3;
      if (7 <= c2) {
        f2 = y2.A(c2);
        for (k2 = 0; 18 > k2; k2 += 1)
          m2 = !b3 && 1 == (f2 >> k2 & 1), r2[Math.floor(k2 / 3)][k2 % 3 + d2 - 8 - 3] = m2;
        for (k2 = 0; 18 > k2; k2 += 1)
          m2 = !b3 && 1 == (f2 >> k2 & 1), r2[k2 % 3 + d2 - 8 - 3][Math.floor(k2 / 3)] = m2;
      }
      if (null == g2) {
        b3 = t2.I(c2, h2);
        f2 = B2();
        for (k2 = 0; k2 < x2.length; k2 += 1)
          m2 = x2[k2], f2.put(4, 4), f2.put(m2.b(), y2.f(4, c2)), m2.write(f2);
        for (k2 = m2 = 0; k2 < b3.length; k2 += 1)
          m2 += b3[k2].j;
        if (f2.f() > 8 * m2)
          throw Error("code length overflow. (" + f2.f() + ">" + 8 * m2 + ")");
        for (f2.f() + 4 <= 8 * m2 && f2.put(0, 4); 0 != f2.f() % 8; )
          f2.m(false);
        for (; !(f2.f() >= 8 * m2); ) {
          f2.put(236, 8);
          if (f2.f() >= 8 * m2)
            break;
          f2.put(17, 8);
        }
        var u3 = 0;
        m2 = k2 = 0;
        p2 = Array(b3.length);
        q2 = Array(b3.length);
        for (n2 = 0; n2 < b3.length; n2 += 1) {
          var v3 = b3[n2].j, w3 = b3[n2].o - v3;
          k2 = Math.max(k2, v3);
          m2 = Math.max(m2, w3);
          p2[n2] = Array(v3);
          for (l2 = 0; l2 < p2[n2].length; l2 += 1)
            p2[n2][l2] = 255 & f2.B()[l2 + u3];
          u3 += v3;
          l2 = y2.C(w3);
          v3 = z2(p2[n2], l2.b() - 1).l(l2);
          q2[n2] = Array(l2.b() - 1);
          for (l2 = 0; l2 < q2[n2].length; l2 += 1)
            w3 = l2 + v3.b() - q2[n2].length, q2[n2][l2] = 0 <= w3 ? v3.c(w3) : 0;
        }
        for (l2 = f2 = 0; l2 < b3.length; l2 += 1)
          f2 += b3[l2].o;
        f2 = Array(f2);
        for (l2 = u3 = 0; l2 < k2; l2 += 1)
          for (n2 = 0; n2 < b3.length; n2 += 1)
            l2 < p2[n2].length && (f2[u3] = p2[n2][l2], u3 += 1);
        for (l2 = 0; l2 < m2; l2 += 1)
          for (n2 = 0; n2 < b3.length; n2 += 1)
            l2 < q2[n2].length && (f2[u3] = q2[n2][l2], u3 += 1);
        g2 = f2;
      }
      b3 = g2;
      f2 = -1;
      k2 = d2 - 1;
      m2 = 7;
      p2 = 0;
      a3 = y2.F(a3);
      for (q2 = d2 - 1; 0 < q2; q2 -= 2)
        for (6 == q2 && --q2; ; ) {
          for (n2 = 0; 2 > n2; n2 += 1)
            null == r2[k2][q2 - n2] && (l2 = false, p2 < b3.length && (l2 = 1 == (b3[p2] >>> m2 & 1)), a3(k2, q2 - n2) && (l2 = !l2), r2[k2][q2 - n2] = l2, --m2, -1 == m2 && (p2 += 1, m2 = 7));
          k2 += f2;
          if (0 > k2 || d2 <= k2) {
            k2 -= f2;
            f2 = -f2;
            break;
          }
        }
    }
    var h2 = A2[a2], r2 = null, d2 = 0, g2 = null, x2 = [], u2 = { u: function(b3) {
      b3 = w2(b3);
      x2.push(b3);
      g2 = null;
    }, a: function(b3, a3) {
      if (0 > b3 || d2 <= b3 || 0 > a3 || d2 <= a3)
        throw Error(b3 + "," + a3);
      return r2[b3][a3];
    }, h: function() {
      return d2;
    }, J: function() {
      for (var a3 = 0, h3 = 0, c3 = 0; 8 > c3; c3 += 1) {
        b2(true, c3);
        var d3 = y2.D(u2);
        if (0 == c3 || a3 > d3)
          a3 = d3, h3 = c3;
      }
      b2(false, h3);
    } };
    return u2;
  }
  function z2(c2, a2) {
    if ("undefined" == typeof c2.length)
      throw Error(c2.length + "/" + a2);
    var e2 = function() {
      for (var b3 = 0; b3 < c2.length && 0 == c2[b3]; )
        b3 += 1;
      for (var r2 = Array(c2.length - b3 + a2), d2 = 0; d2 < c2.length - b3; d2 += 1)
        r2[d2] = c2[d2 + b3];
      return r2;
    }(), b2 = { c: function(b3) {
      return e2[b3];
    }, b: function() {
      return e2.length;
    }, multiply: function(a3) {
      for (var h2 = Array(b2.b() + a3.b() - 1), c3 = 0; c3 < b2.b(); c3 += 1)
        for (var g2 = 0; g2 < a3.b(); g2 += 1)
          h2[c3 + g2] ^= v2.i(v2.g(b2.c(c3)) + v2.g(a3.c(g2)));
      return z2(h2, 0);
    }, l: function(a3) {
      if (0 > b2.b() - a3.b())
        return b2;
      for (var c3 = v2.g(b2.c(0)) - v2.g(a3.c(0)), h2 = Array(b2.b()), g2 = 0; g2 < b2.b(); g2 += 1)
        h2[g2] = b2.c(g2);
      for (g2 = 0; g2 < a3.b(); g2 += 1)
        h2[g2] ^= v2.i(v2.g(a3.c(g2)) + c3);
      return z2(h2, 0).l(a3);
    } };
    return b2;
  }
  C2.s = function(c2) {
    for (var a2 = [], e2 = 0; e2 < c2.length; e2++) {
      var b2 = c2.charCodeAt(e2);
      128 > b2 ? a2.push(b2) : 2048 > b2 ? a2.push(192 | b2 >> 6, 128 | b2 & 63) : 55296 > b2 || 57344 <= b2 ? a2.push(224 | b2 >> 12, 128 | b2 >> 6 & 63, 128 | b2 & 63) : (e2++, b2 = 65536 + ((b2 & 1023) << 10 | c2.charCodeAt(e2) & 1023), a2.push(240 | b2 >> 18, 128 | b2 >> 12 & 63, 128 | b2 >> 6 & 63, 128 | b2 & 63));
    }
    return a2;
  };
  var A2 = { L: 1, M: 0, Q: 3, H: 2 }, y2 = function() {
    function c2(b2) {
      for (var a3 = 0; 0 != b2; )
        a3 += 1, b2 >>>= 1;
      return a3;
    }
    var a2 = [
      [],
      [6, 18],
      [6, 22],
      [6, 26],
      [6, 30],
      [6, 34],
      [6, 22, 38],
      [6, 24, 42],
      [6, 26, 46],
      [6, 28, 50],
      [6, 30, 54],
      [6, 32, 58],
      [6, 34, 62],
      [6, 26, 46, 66],
      [6, 26, 48, 70],
      [6, 26, 50, 74],
      [6, 30, 54, 78],
      [6, 30, 56, 82],
      [6, 30, 58, 86],
      [6, 34, 62, 90],
      [6, 28, 50, 72, 94],
      [6, 26, 50, 74, 98],
      [6, 30, 54, 78, 102],
      [6, 28, 54, 80, 106],
      [6, 32, 58, 84, 110],
      [6, 30, 58, 86, 114],
      [6, 34, 62, 90, 118],
      [6, 26, 50, 74, 98, 122],
      [6, 30, 54, 78, 102, 126],
      [6, 26, 52, 78, 104, 130],
      [6, 30, 56, 82, 108, 134],
      [6, 34, 60, 86, 112, 138],
      [6, 30, 58, 86, 114, 142],
      [6, 34, 62, 90, 118, 146],
      [6, 30, 54, 78, 102, 126, 150],
      [6, 24, 50, 76, 102, 128, 154],
      [6, 28, 54, 80, 106, 132, 158],
      [6, 32, 58, 84, 110, 136, 162],
      [6, 26, 54, 82, 110, 138, 166],
      [6, 30, 58, 86, 114, 142, 170]
    ], e2 = { w: function(b2) {
      for (var a3 = b2 << 10; 0 <= c2(a3) - c2(1335); )
        a3 ^= 1335 << c2(a3) - c2(1335);
      return (b2 << 10 | a3) ^ 21522;
    }, A: function(b2) {
      for (var a3 = b2 << 12; 0 <= c2(a3) - c2(7973); )
        a3 ^= 7973 << c2(a3) - c2(7973);
      return b2 << 12 | a3;
    }, G: function(b2) {
      return a2[b2 - 1];
    }, F: function(b2) {
      switch (b2) {
        case 0:
          return function(b3, a3) {
            return 0 == (b3 + a3) % 2;
          };
        case 1:
          return function(b3) {
            return 0 == b3 % 2;
          };
        case 2:
          return function(b3, a3) {
            return 0 == a3 % 3;
          };
        case 3:
          return function(b3, a3) {
            return 0 == (b3 + a3) % 3;
          };
        case 4:
          return function(b3, a3) {
            return 0 == (Math.floor(b3 / 2) + Math.floor(a3 / 3)) % 2;
          };
        case 5:
          return function(b3, a3) {
            return 0 == b3 * a3 % 2 + b3 * a3 % 3;
          };
        case 6:
          return function(b3, a3) {
            return 0 == (b3 * a3 % 2 + b3 * a3 % 3) % 2;
          };
        case 7:
          return function(b3, a3) {
            return 0 == (b3 * a3 % 3 + (b3 + a3) % 2) % 2;
          };
        default:
          throw Error("bad maskPattern:" + b2);
      }
    }, C: function(b2) {
      for (var a3 = z2([1], 0), c3 = 0; c3 < b2; c3 += 1)
        a3 = a3.multiply(z2([1, v2.i(c3)], 0));
      return a3;
    }, f: function(b2, a3) {
      if (4 != b2 || 1 > a3 || 40 < a3)
        throw Error("mode: " + b2 + "; type: " + a3);
      return 10 > a3 ? 8 : 16;
    }, D: function(b2) {
      for (var a3 = b2.h(), c3 = 0, d2 = 0; d2 < a3; d2 += 1)
        for (var g2 = 0; g2 < a3; g2 += 1) {
          for (var e3 = 0, t3 = b2.a(d2, g2), p2 = -1; 1 >= p2; p2 += 1)
            if (!(0 > d2 + p2 || a3 <= d2 + p2))
              for (var q2 = -1; 1 >= q2; q2 += 1)
                0 > g2 + q2 || a3 <= g2 + q2 || (0 != p2 || 0 != q2) && t3 == b2.a(d2 + p2, g2 + q2) && (e3 += 1);
          5 < e3 && (c3 += 3 + e3 - 5);
        }
      for (d2 = 0; d2 < a3 - 1; d2 += 1)
        for (g2 = 0; g2 < a3 - 1; g2 += 1)
          if (e3 = 0, b2.a(d2, g2) && (e3 += 1), b2.a(d2 + 1, g2) && (e3 += 1), b2.a(d2, g2 + 1) && (e3 += 1), b2.a(d2 + 1, g2 + 1) && (e3 += 1), 0 == e3 || 4 == e3)
            c3 += 3;
      for (d2 = 0; d2 < a3; d2 += 1)
        for (g2 = 0; g2 < a3 - 6; g2 += 1)
          b2.a(d2, g2) && !b2.a(d2, g2 + 1) && b2.a(d2, g2 + 2) && b2.a(d2, g2 + 3) && b2.a(d2, g2 + 4) && !b2.a(d2, g2 + 5) && b2.a(d2, g2 + 6) && (c3 += 40);
      for (g2 = 0; g2 < a3; g2 += 1)
        for (d2 = 0; d2 < a3 - 6; d2 += 1)
          b2.a(d2, g2) && !b2.a(d2 + 1, g2) && b2.a(d2 + 2, g2) && b2.a(d2 + 3, g2) && b2.a(d2 + 4, g2) && !b2.a(d2 + 5, g2) && b2.a(d2 + 6, g2) && (c3 += 40);
      for (g2 = e3 = 0; g2 < a3; g2 += 1)
        for (d2 = 0; d2 < a3; d2 += 1)
          b2.a(d2, g2) && (e3 += 1);
      return c3 += Math.abs(100 * e3 / a3 / a3 - 50) / 5 * 10;
    } };
    return e2;
  }(), v2 = function() {
    for (var c2 = Array(256), a2 = Array(256), e2 = 0; 8 > e2; e2 += 1)
      c2[e2] = 1 << e2;
    for (e2 = 8; 256 > e2; e2 += 1)
      c2[e2] = c2[e2 - 4] ^ c2[e2 - 5] ^ c2[e2 - 6] ^ c2[e2 - 8];
    for (e2 = 0; 255 > e2; e2 += 1)
      a2[c2[e2]] = e2;
    return { g: function(b2) {
      if (1 > b2)
        throw Error("glog(" + b2 + ")");
      return a2[b2];
    }, i: function(b2) {
      for (; 0 > b2; )
        b2 += 255;
      for (; 256 <= b2; )
        b2 -= 255;
      return c2[b2];
    } };
  }(), t2 = function() {
    function c2(b2, c3) {
      switch (c3) {
        case A2.L:
          return a2[4 * (b2 - 1)];
        case A2.M:
          return a2[4 * (b2 - 1) + 1];
        case A2.Q:
          return a2[4 * (b2 - 1) + 2];
        case A2.H:
          return a2[4 * (b2 - 1) + 3];
      }
    }
    var a2 = [
      [1, 26, 19],
      [1, 26, 16],
      [1, 26, 13],
      [1, 26, 9],
      [1, 44, 34],
      [1, 44, 28],
      [1, 44, 22],
      [1, 44, 16],
      [1, 70, 55],
      [1, 70, 44],
      [2, 35, 17],
      [2, 35, 13],
      [1, 100, 80],
      [2, 50, 32],
      [2, 50, 24],
      [4, 25, 9],
      [1, 134, 108],
      [2, 67, 43],
      [2, 33, 15, 2, 34, 16],
      [2, 33, 11, 2, 34, 12],
      [2, 86, 68],
      [4, 43, 27],
      [4, 43, 19],
      [4, 43, 15],
      [2, 98, 78],
      [4, 49, 31],
      [2, 32, 14, 4, 33, 15],
      [4, 39, 13, 1, 40, 14],
      [2, 121, 97],
      [2, 60, 38, 2, 61, 39],
      [4, 40, 18, 2, 41, 19],
      [4, 40, 14, 2, 41, 15],
      [2, 146, 116],
      [
        3,
        58,
        36,
        2,
        59,
        37
      ],
      [4, 36, 16, 4, 37, 17],
      [4, 36, 12, 4, 37, 13],
      [2, 86, 68, 2, 87, 69],
      [4, 69, 43, 1, 70, 44],
      [6, 43, 19, 2, 44, 20],
      [6, 43, 15, 2, 44, 16],
      [4, 101, 81],
      [1, 80, 50, 4, 81, 51],
      [4, 50, 22, 4, 51, 23],
      [3, 36, 12, 8, 37, 13],
      [2, 116, 92, 2, 117, 93],
      [6, 58, 36, 2, 59, 37],
      [4, 46, 20, 6, 47, 21],
      [7, 42, 14, 4, 43, 15],
      [4, 133, 107],
      [8, 59, 37, 1, 60, 38],
      [8, 44, 20, 4, 45, 21],
      [12, 33, 11, 4, 34, 12],
      [3, 145, 115, 1, 146, 116],
      [4, 64, 40, 5, 65, 41],
      [11, 36, 16, 5, 37, 17],
      [11, 36, 12, 5, 37, 13],
      [5, 109, 87, 1, 110, 88],
      [5, 65, 41, 5, 66, 42],
      [5, 54, 24, 7, 55, 25],
      [11, 36, 12, 7, 37, 13],
      [5, 122, 98, 1, 123, 99],
      [
        7,
        73,
        45,
        3,
        74,
        46
      ],
      [15, 43, 19, 2, 44, 20],
      [3, 45, 15, 13, 46, 16],
      [1, 135, 107, 5, 136, 108],
      [10, 74, 46, 1, 75, 47],
      [1, 50, 22, 15, 51, 23],
      [2, 42, 14, 17, 43, 15],
      [5, 150, 120, 1, 151, 121],
      [9, 69, 43, 4, 70, 44],
      [17, 50, 22, 1, 51, 23],
      [2, 42, 14, 19, 43, 15],
      [3, 141, 113, 4, 142, 114],
      [3, 70, 44, 11, 71, 45],
      [17, 47, 21, 4, 48, 22],
      [9, 39, 13, 16, 40, 14],
      [3, 135, 107, 5, 136, 108],
      [3, 67, 41, 13, 68, 42],
      [15, 54, 24, 5, 55, 25],
      [15, 43, 15, 10, 44, 16],
      [4, 144, 116, 4, 145, 117],
      [17, 68, 42],
      [17, 50, 22, 6, 51, 23],
      [19, 46, 16, 6, 47, 17],
      [2, 139, 111, 7, 140, 112],
      [17, 74, 46],
      [7, 54, 24, 16, 55, 25],
      [34, 37, 13],
      [
        4,
        151,
        121,
        5,
        152,
        122
      ],
      [4, 75, 47, 14, 76, 48],
      [11, 54, 24, 14, 55, 25],
      [16, 45, 15, 14, 46, 16],
      [6, 147, 117, 4, 148, 118],
      [6, 73, 45, 14, 74, 46],
      [11, 54, 24, 16, 55, 25],
      [30, 46, 16, 2, 47, 17],
      [8, 132, 106, 4, 133, 107],
      [8, 75, 47, 13, 76, 48],
      [7, 54, 24, 22, 55, 25],
      [22, 45, 15, 13, 46, 16],
      [10, 142, 114, 2, 143, 115],
      [19, 74, 46, 4, 75, 47],
      [28, 50, 22, 6, 51, 23],
      [33, 46, 16, 4, 47, 17],
      [8, 152, 122, 4, 153, 123],
      [22, 73, 45, 3, 74, 46],
      [8, 53, 23, 26, 54, 24],
      [12, 45, 15, 28, 46, 16],
      [3, 147, 117, 10, 148, 118],
      [3, 73, 45, 23, 74, 46],
      [4, 54, 24, 31, 55, 25],
      [11, 45, 15, 31, 46, 16],
      [7, 146, 116, 7, 147, 117],
      [21, 73, 45, 7, 74, 46],
      [1, 53, 23, 37, 54, 24],
      [19, 45, 15, 26, 46, 16],
      [5, 145, 115, 10, 146, 116],
      [19, 75, 47, 10, 76, 48],
      [15, 54, 24, 25, 55, 25],
      [23, 45, 15, 25, 46, 16],
      [13, 145, 115, 3, 146, 116],
      [2, 74, 46, 29, 75, 47],
      [42, 54, 24, 1, 55, 25],
      [23, 45, 15, 28, 46, 16],
      [17, 145, 115],
      [10, 74, 46, 23, 75, 47],
      [10, 54, 24, 35, 55, 25],
      [19, 45, 15, 35, 46, 16],
      [17, 145, 115, 1, 146, 116],
      [14, 74, 46, 21, 75, 47],
      [29, 54, 24, 19, 55, 25],
      [11, 45, 15, 46, 46, 16],
      [13, 145, 115, 6, 146, 116],
      [14, 74, 46, 23, 75, 47],
      [44, 54, 24, 7, 55, 25],
      [59, 46, 16, 1, 47, 17],
      [12, 151, 121, 7, 152, 122],
      [12, 75, 47, 26, 76, 48],
      [39, 54, 24, 14, 55, 25],
      [22, 45, 15, 41, 46, 16],
      [6, 151, 121, 14, 152, 122],
      [6, 75, 47, 34, 76, 48],
      [46, 54, 24, 10, 55, 25],
      [2, 45, 15, 64, 46, 16],
      [17, 152, 122, 4, 153, 123],
      [29, 74, 46, 14, 75, 47],
      [49, 54, 24, 10, 55, 25],
      [24, 45, 15, 46, 46, 16],
      [4, 152, 122, 18, 153, 123],
      [13, 74, 46, 32, 75, 47],
      [48, 54, 24, 14, 55, 25],
      [42, 45, 15, 32, 46, 16],
      [20, 147, 117, 4, 148, 118],
      [40, 75, 47, 7, 76, 48],
      [43, 54, 24, 22, 55, 25],
      [10, 45, 15, 67, 46, 16],
      [19, 148, 118, 6, 149, 119],
      [18, 75, 47, 31, 76, 48],
      [34, 54, 24, 34, 55, 25],
      [20, 45, 15, 61, 46, 16]
    ], e2 = { I: function(b2, a3) {
      var e3 = c2(b2, a3);
      if ("undefined" == typeof e3)
        throw Error("bad rs block @ typeNumber:" + b2 + "/errorCorrectLevel:" + a3);
      b2 = e3.length / 3;
      a3 = [];
      for (var d2 = 0; d2 < b2; d2 += 1)
        for (var g2 = e3[3 * d2], h2 = e3[3 * d2 + 1], t3 = e3[3 * d2 + 2], p2 = 0; p2 < g2; p2 += 1) {
          var q2 = t3, f2 = {};
          f2.o = h2;
          f2.j = q2;
          a3.push(f2);
        }
      return a3;
    } };
    return e2;
  }();
  return C2;
}());
const QrCreator$1 = QrCreator;
const useClipboard = (opts = {}) => {
  const copy = async (value) => {
    if (navigator.clipboard) {
      const promise = navigator.clipboard.writeText(value);
      if (opts.onError)
        promise.catch(opts.onError);
      if (opts.onCopy)
        promise.then(opts.onCopy);
      return await promise;
    } else if (opts.onError)
      opts.onError(new DOMException("No clipboard in navigator"));
  };
  return {
    copy
  };
};
const CopyText$1 = "ejx-CopyText";
const CopyText_UrlText = "ejx-CopyText_UrlText";
const CopyText_UrlText__Selectable = "ejx-CopyText_UrlText__Selectable";
const CopyText_Copy = "ejx-CopyText_Copy";
const CopyText_CopyIcon = "ejx-CopyText_CopyIcon";
const CopyText_CopyIcon__Visible = "ejx-CopyText_CopyIcon__Visible";
const CopyText_CopyIcon__Check = "ejx-CopyText_CopyIcon__Check";
const CopyText_Popup = "ejx-CopyText_Popup";
const styles$1 = {
  CopyText: CopyText$1,
  CopyText_UrlText,
  CopyText_UrlText__Selectable,
  CopyText_Copy,
  CopyText_CopyIcon,
  CopyText_CopyIcon__Visible,
  CopyText_CopyIcon__Check,
  CopyText_Popup
};
const CopyText = (props) => {
  const [hasCopyPermissions, setHasCopyPermissions] = p(true);
  const [copied, setCopied] = p(false);
  const copiedTimeoutRef = F();
  const {
    copy
  } = useClipboard({
    onCopy: () => {
      if (props.onCopy)
        props.onCopy();
      setCopied(true);
      if (copiedTimeoutRef.current !== void 0) {
        window.clearTimeout(copiedTimeoutRef.current);
        copiedTimeoutRef.current = void 0;
      }
      copiedTimeoutRef.current = window.setTimeout(() => {
        copiedTimeoutRef.current = void 0;
        setCopied(false);
      }, 1e3);
    }
  });
  _(() => {
    if (!props.parentOpen) {
      const sel = document.getSelection();
      if (sel) {
        sel.removeAllRanges();
      }
    }
  }, [props.parentOpen]);
  const textEl = F(null);
  const handleClick = x(() => {
    copy(props.text).catch(() => {
      setHasCopyPermissions(false);
      if (!textEl.current)
        return;
      selectElement(textEl.current);
    });
  }, [copy, props.text]);
  return u("div", {
    className: clsx(styles$1.CopyText, props.className),
    onClick: handleClick,
    children: [u("span", {
      ref: textEl,
      className: clsx(styles$1.CopyText_UrlText, !hasCopyPermissions && styles$1.CopyText_UrlText__Selectable),
      children: props.text
    }), hasCopyPermissions && u("div", {
      className: styles$1.CopyText_Copy,
      children: [u("svg", {
        className: clsx(styles$1.CopyText_CopyIcon, !copied && styles$1.CopyText_CopyIcon__Visible),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [u("path", {
          d: "M5.75 4.75H10.25V1.75H5.75V4.75Z"
        }), u("path", {
          d: "M3.25 2.88379C2.9511 3.05669 2.75 3.37987 2.75 3.75001V13.25C2.75 13.8023 3.19772 14.25 3.75 14.25H12.25C12.8023 14.25 13.25 13.8023 13.25 13.25V3.75001C13.25 3.37987 13.0489 3.05669 12.75 2.88379"
        })]
      }), u("svg", {
        className: clsx(styles$1.CopyText_CopyIcon, styles$1.CopyText_CopyIcon__Check, copied && styles$1.CopyText_CopyIcon__Visible),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: u("path", {
          d: "M13.25 4.75L6 12L2.75 8.75"
        })
      })]
    })]
  });
};
const DesktopPopupContents$1 = "ejx-DesktopPopupContents";
const DesktopPopupContents_Qr = "ejx-DesktopPopupContents_Qr";
const DesktopPopupContents_Text = "ejx-DesktopPopupContents_Text";
const styles = {
  DesktopPopupContents: DesktopPopupContents$1,
  DesktopPopupContents_Qr,
  DesktopPopupContents_Text
};
const DesktopPopupContents = (props) => {
  const [canvasEl, setCanvasEl] = p();
  _(() => {
    if (canvasEl) {
      QrCreator$1.render({
        text: props.targetUrl,
        radius: 0.2,
        background: null,
        fill: "#000",
        size: 512
      }, canvasEl);
    }
  }, [props.targetUrl, canvasEl]);
  return u("div", {
    className: styles.DesktopPopupContents,
    children: [u("canvas", {
      ref: (el) => setCanvasEl(el),
      className: styles.DesktopPopupContents_Qr,
      id: "launch-button-qr",
      onTouchStart: (e2) => e2.preventDefault()
    }), "Scan the QR code to Play in XR", u(CopyText, {
      text: props.targetUrl,
      parentOpen: props.visible
    })]
  });
};
const useClickOutside = (handler) => {
  const [element, setElement] = p(null);
  _(() => {
    const clickHandler = (e2) => {
      if (element && !element.contains(e2.target)) {
        handler(e2);
      }
    };
    if (element) {
      window.addEventListener("click", clickHandler);
    }
    return () => {
      window.removeEventListener("click", clickHandler);
    };
  }, [element, handler]);
  return setElement;
};
function useWindowSize() {
  const [windowSize, setWindowSize] = p({
    width: void 0,
    height: void 0
  });
  _(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
const PickSessionString = {
  "immersive-ar": "AR",
  "immersive-vr": "VR"
};
const LauncherButton = (props) => {
  var _a, _b, _c, _d, _e;
  const {
    session,
    currentSessionType,
    tryStartXR: tryStartXRInternal,
    tryStopXR
  } = useXRSession({
    xrSessionBuilder: props.xrSessionBuilder,
    xrSessionEnder: props.xrSessionEnder,
    onBeforeStart: props.onBeforeStart,
    onStart: props.onStart,
    onBeforeEnd: props.onBeforeEnd,
    onEnd: props.onEnd,
    onError: props.onError
  });
  const [showButton, setShowButton] = p(true);
  const [popupVisible, setPopupVisible] = p(((_a = props.appearance) == null ? void 0 : _a.redirectPopupOpen) ?? false);
  const [statusPopupVisible, setStatusPopupVisible] = p(false);
  const [url, setUrl] = p(props.launchUrl ?? window.location.toString());
  const [baseUrl, setBaseUrl] = p(props.launchBaseUrl ?? "https://play.eyejack.xyz/link?url=");
  const [buttonText, setButtonText] = p(((_b = props.appearance) == null ? void 0 : _b.buttonText) ?? "Play");
  const [cssVariables, setCssVariables] = p({
    "--ejx-border-color": ((_c = props.appearance) == null ? void 0 : _c.borderColor) ?? "#C0FB00",
    "--ejx-border-color-deemphasized": ((_d = props.appearance) == null ? void 0 : _d.deemphasizedBorderColor) ?? "#597500"
  });
  const launchUrl = baseUrl + (needsUrlEncoded(url) ? encodeURIComponent(url) : url);
  const setElement = useClickOutside(() => {
    setPopupVisible(false);
    setStatusPopupVisible(false);
    if (pickSessionTypeVisible) {
      setPickSessionTypeVisible(false);
    }
  });
  const [validSessionTypes, setValidSessionTypes] = p([]);
  const [pickSessionTypeVisible, setPickSessionTypeVisible] = p(false);
  const [status, setStatus] = p();
  const tryStartXR = x((sessionType) => {
    tryStartXRInternal(sessionType).catch((reason) => {
      if (reason instanceof DOMException) {
        if (reason.name === "SecurityError" || reason.name === "NotSupportedError") {
          setStatusPopupVisible(true);
          if (sessionType === "immersive-ar")
            setStatus(CheckXRStatus.USER_REJECT_AR);
          else if (sessionType === "immersive-vr")
            setStatus(CheckXRStatus.USER_REJECT_VR);
          if (props.onError)
            props.onError(new XRPermissionsError());
        } else if (props.onError) {
          props.onError(new UnknownError(reason.message));
        }
      }
    });
  }, [tryStartXRInternal, props]);
  A(() => {
    const handler = (evt) => {
      if (evt.data.type === "@eyejack/ejx-launcher-button:configure") {
        const {
          data
        } = evt;
        if (data.launchUrl !== void 0)
          setUrl(data.launchUrl);
        if (data.launchBaseUrl !== void 0)
          setBaseUrl(data.launchBaseUrl);
        const {
          appearance: appearance2
        } = data;
        if (appearance2) {
          if (appearance2.showButton !== void 0)
            setShowButton(appearance2.showButton);
          if (appearance2.buttonText)
            setButtonText(appearance2.buttonText);
          if (appearance2.borderColor)
            setCssVariables((prev) => ({
              ...prev,
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              "--ejx-border-color": appearance2.borderColor
            }));
          if (appearance2.deemphasizedBorderColor)
            setCssVariables((prev) => ({
              ...prev,
              "--ejx-border-color-deemphasized": (
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance2.deemphasizedBorderColor
              )
            }));
        }
      }
    };
    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("@eyejack/ejx-launcher-button:configure", handler);
    };
  }, []);
  window.EJXStartXr = tryStartXR;
  const handleLaunch = async () => {
    const {
      status: status2,
      sessions
    } = await checkXr(props.supportedSessionTypes);
    setStatus(status2);
    const error = ejxLauncherErrorFromCheckXRStatus(status2);
    if (error && props.onError) {
      props.onError(error);
    }
    if (session) {
      tryStopXR();
    } else if (status2 === CheckXRStatus.OK) {
      if (sessions.length === 1) {
        tryStartXR(sessions[0]);
        return;
      } else {
        setValidSessionTypes(sessions);
        setPickSessionTypeVisible(!pickSessionTypeVisible);
        return;
      }
    } else if (status2 === CheckXRStatus.IOS) {
      if (isInIframe()) {
        const customEvent = new CustomEvent("@eyejack/ejx-launcher-button:redirect", {
          detail: {
            launchUrl
          }
        });
        broadcastEvent(customEvent);
        let hasNavigatedAway = false;
        const handleBlur = () => {
          hasNavigatedAway = true;
          setStatusPopupVisible(false);
          window.removeEventListener("blur", handleBlur);
        };
        window.addEventListener("blur", handleBlur, {
          once: true
        });
        setTimeout(() => {
          if (!hasNavigatedAway) {
            setStatusPopupVisible(true);
            setStatus(CheckXRStatus.SHOW_IFRAME_REDIRECT);
          }
        }, 500);
      } else {
        window.location.href = launchUrl;
      }
    } else if (status2 === CheckXRStatus.SHOW_POPUP) {
      setPopupVisible(!popupVisible);
    } else {
      setStatusPopupVisible(true);
    }
  };
  _(() => {
    if (!session) {
      setPickSessionTypeVisible(false);
    }
  }, [session]);
  const statusPopupContent = q(() => {
    if (!statusPopupVisible)
      return void 0;
    if (status === CheckXRStatus.NO_HTTPS) {
      return {
        title: "Uh oh!",
        description: "WebXR requires HTTPS to work.  Make sure the website has a valid https certificate."
      };
    } else if (status === CheckXRStatus.ANDROID_NO_XR) {
      return {
        title: "Uh oh!",
        description: "This browser doesn't support WebXR.  Please use the latest Google Chrome.",
        copyText: launchUrl
      };
    } else if (status === CheckXRStatus.NAVIGATOR_XR_PERMISSIONS) {
      return {
        title: "Uh oh!",
        description: "The device, website, or iframe does not permit XR sessions. Try allowing WebXR in permissions."
      };
    } else if (status === CheckXRStatus.USER_REJECT_VR) {
      return {
        title: "Uh oh!",
        description: "Please allow Virtual Reality permissions"
      };
    } else if (status === CheckXRStatus.USER_REJECT_AR) {
      return {
        title: "Uh oh!",
        description: "Please allow Augmented Reality permissions"
      };
    } else if (status === CheckXRStatus.SHOW_IFRAME_REDIRECT) {
      return {
        description: "Copy link to Play in XR",
        copyText: launchUrl
      };
    } else if (status === CheckXRStatus.NO_FULLSCREEN) {
      return {
        description: "Copy link to Play in XR",
        copyText: launchUrl
      };
    }
    console.error("Unhandled status error.");
  }, [status, statusPopupVisible, launchUrl]);
  const {
    height: windowHeight
  } = useWindowSize();
  if (!showButton)
    return null;
  const {
    appearance
  } = props;
  const showCloseButton = (appearance == null ? void 0 : appearance.showCloseButton) !== void 0 ? appearance.showCloseButton : true;
  return u("div", {
    className: clsx(styles$3.LaunchRoot, pickSessionTypeVisible && styles$3.LaunchRoot__pickvisible, ((appearance == null ? void 0 : appearance.variant) === "default" || !(appearance == null ? void 0 : appearance.variant)) && styles$3.LaunchRoot__variantdefault, (appearance == null ? void 0 : appearance.variant) === "minimal" && styles$3.LaunchRoot__variantminimal),
    style: {
      "--win-height": `${windowHeight}px`,
      ...cssVariables
    },
    children: [showCloseButton && session && currentSessionType && u("svg", {
      className: styles$3.CloseButton,
      onClickCapture: handleLaunch,
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [u("path", {
        d: "M3 3L29 29",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
      }), u("path", {
        d: "M3 29L29 3",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
      })]
    }), u("div", {
      ref: (el) => setElement(el),
      className: styles$3.LaunchButtonWrapper,
      children: [(!session || !currentSessionType) && u("div", {
        className: styles$3.LaunchButton,
        onClickCapture: handleLaunch,
        children: u("button", {
          className: clsx(styles$3.Button, ((_e = props.appearance) == null ? void 0 : _e.variant) === "minimal" && styles$3.Button__Small, pickSessionTypeVisible && styles$3.LaunchButton__Deemphasize),
          children: buttonText
        })
      }), u("div", {
        className: clsx(styles$3.SessionButtonWrapper, pickSessionTypeVisible && styles$3.SessionButtonWrapper__Visible),
        children: validSessionTypes.map((seshType) => u("button", {
          className: clsx(styles$3.Button, styles$3.Button__Small),
          onClickCapture: () => {
            tryStartXR(seshType);
            setPickSessionTypeVisible(false);
          },
          children: PickSessionString[seshType]
        }, seshType))
      }), u(LauncherPopup, {
        visible: popupVisible,
        children: u(DesktopPopupContents, {
          targetUrl: launchUrl,
          supportedTypes: props.supportedSessionTypes,
          visible: popupVisible
        })
      }), u(LauncherPopup, {
        visible: !!(statusPopupContent && statusPopupVisible),
        children: [u("h3", {
          className: styles$3.EJXText,
          children: statusPopupContent == null ? void 0 : statusPopupContent.title
        }), u("p", {
          className: styles$3.EJXText,
          children: statusPopupContent == null ? void 0 : statusPopupContent.description
        }), (statusPopupContent == null ? void 0 : statusPopupContent.copyText) && u(CopyText, {
          text: statusPopupContent.copyText,
          parentOpen: !!(statusPopupContent && statusPopupVisible)
        })]
      })]
    })]
  });
};
function isObject(item) {
  return !!(item && typeof item === "object" && !Array.isArray(item));
}
const ARSession = "immersive-ar";
const VRSession = "immersive-vr";
const showLaunchButton = (opts) => {
  if (!opts.arOptions && !opts.vrOptions) {
    throw new Error("@eyejack/ejx-launcher-button requires `arOptions` or `vrOptions` to be provided.");
  }
  const supportedSessionTypes = [];
  if (opts.arOptions) {
    supportedSessionTypes.push(ARSession);
  }
  if (opts.vrOptions) {
    supportedSessionTypes.push(VRSession);
  }
  const wrapper = document.createElement("div");
  wrapper.setAttribute("id", "ejx-launcher-button");
  B$1(y$1(LauncherButton, {
    xrSessionBuilder: opts.xrSessionBuilder,
    xrSessionEnder: opts.xrSessionEnder,
    supportedSessionTypes,
    onBeforeStart: opts.onBeforeStart,
    onBeforeEnd: opts.onBeforeEnd,
    onStart: opts.onStart,
    onEnd: opts.onEnd,
    onError: opts.onError,
    launchUrl: opts.launchUrl,
    launchBaseUrl: opts.launchBaseUrl,
    appearance: opts.appearance
  }), wrapper);
  (opts.container ?? document.body).appendChild(wrapper);
  return wrapper;
};
const showThreeLaunchButton = ({
  renderer,
  arReferenceSpace = "local",
  vrReferenceSpace,
  ...opts
}) => {
  const wrapper = showLaunchButton({
    ...opts,
    xrSessionBuilder: async (sessionType) => {
      var _a;
      const xrOptions = (() => {
        if (sessionType === "immersive-ar" && opts.arOptions) {
          return opts.arOptions;
        } else if (sessionType === "immersive-vr" && opts.vrOptions) {
          return opts.vrOptions;
        }
        throw new Error(`@eyejack/ejx-launcher-button: Trying to build xr session with session type ${sessionType}.  This session type is not supported.`);
      })();
      if (!xrOptions.optionalFeatures) {
        xrOptions.optionalFeatures = [];
      }
      if (!xrOptions.optionalFeatures.includes("dom-overlay")) {
        xrOptions.optionalFeatures.push("dom-overlay");
      }
      xrOptions.domOverlay = {
        root: opts.container ?? wrapper
      };
      const session = await ((_a = navigator.xr) == null ? void 0 : _a.requestSession(sessionType, xrOptions));
      if (!session) {
        throw new Error("Session could not be created.");
      }
      if (sessionType === "immersive-ar" && arReferenceSpace) {
        renderer.xr.setReferenceSpaceType(arReferenceSpace);
      }
      if (sessionType === "immersive-vr" && vrReferenceSpace) {
        renderer.xr.setReferenceSpaceType(vrReferenceSpace);
      }
      await renderer.xr.setSession(session);
      return session;
    },
    xrSessionEnder: (session) => {
      return session.end();
    }
  });
  return wrapper;
};
export {
  ARSession,
  VRSession,
  isObject,
  showLaunchButton,
  showThreeLaunchButton
};
